export default {
  status                    : {
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  reportDatas: [],
  reportDebtCollectionType: [
    { value: 'reportDebtCollection30Day', label: 'หนังสือติดตามทวงถามหนี้ 30 วัน' },
    { value: 'reportDebtCollection60Day', label: 'หนังสือติดตามทวงถามหนี้ 60 วัน' },
  ],
  reportOnlyBorrower: [
    { value: 'onlyBorrower', label: 'เฉพาะผู้กู้' },
    { value: 'borrowerAndGuarantor', label: 'ผู้กู้และผู้ค้ำประกัน' },
  ],
  reportProsecutionFilter: [
    { value: 'all', label: 'ทั้งหมด' },
    { value: 'onlyProsecution', label: 'เฉพาะการดำเนินคดี' },
    { value: 'onlyNonProsecution', label: 'เฉพาะไม่ดำเนินคดี' },
  ],
}
